import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  computed: {
    model: {
      get() {
        if (this.value === null || this.value === '') return;
        return this.value;
      },
      set(newVal) {
        this.$emit('input', newVal);
      },
    },
  },
})
export default class VCustomSelect extends Vue {
  @Prop()
  value: any;
  @Prop()
  id: any;
  @Prop()
  name: any;
  @Prop()
  dataCy: any;
  @Prop()
  label: any;
  @Prop()
  errorMessages: any;
  @Prop()
  dense: false;
  @Prop()
  outlined: false;
  @Prop()
  required: false;
  @Prop()
  readonly: false;
  @Prop()
  disabled: false;
  @Prop()
  singleLine: false;
  @Prop({ default: false })
  hideDetails: boolean;

  public numericReg = /^.*[0-9].*$/;

  public numericOnly(event: any) {
    if (!this.numericReg.test(event.key)) {
      event.preventDefault();
    }
  }
}
